import { ConsultationProcess } from './types'

type LoadDataType = {
  checkup: Record<string, Record<string, ConsultationProcess>>
  common_checkup: Record<string, ConsultationProcess>
}

export const loadedData: LoadDataType = {
  checkup: {
    diarrhea: {
      frequency: {
        title: 'How frequently\ndoes diarrhea occur?',
        component: {
          type: 'select',
          options: [
            {
              value: 'Multiple times a day',
            },
            {
              value: 'Daily',
            },
            {
              value: 'Weekly',
            },
            {
              value: 'Episodic (at certain triggers)',
            },
          ],
        },
      },
      experiencing_other_issues: {
        title: 'Is your pet experiencing\nany other issues?',
        description: 'This will help us better understand\nyour pet’s health.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: false,
          options: [
            {
              value: 'Vomiting',
              groupBy: 'most asked',
            },
            {
              value: 'Ear',
              groupBy: 'most asked',
            },
            {
              value: 'Eye',
              groupBy: 'most asked',
            },
            {
              value: 'Behavior',
              groupBy: 'most asked',
            },
            {
              value: 'Lethargy',
              groupBy: 'most asked',
            },
            {
              value: 'Loss of appetite',
              groupBy: 'most asked',
            },
            {
              value: 'Toxic ingestion',
              groupBy: 'most asked',
            },
            {
              value: 'Weight loss',
              groupBy: 'most asked',
            },
            {
              value: 'Obesity',
              groupBy: 'most asked',
            },
            {
              value: 'Nose',
              groupBy: 'most asked',
            },
            {
              value: 'Heartworms',
              groupBy: 'most asked',
            },
            {
              value: 'Coughing',
              groupBy: 'respiratory',
            },
            {
              value: 'Sneezing',
              groupBy: 'respiratory',
            },
            {
              value: 'Stinky breath',
              groupBy: 'respiratory',
            },
            {
              value: 'Difficulty breathing',
              groupBy: 'respiratory',
            },
            {
              value: 'Skin',
              groupBy: 'skin',
            },
            {
              value: 'Itching',
              groupBy: 'skin',
            },
            {
              value: 'Fleas',
              groupBy: 'skin',
            },
            {
              value: 'Ticks',
              groupBy: 'skin',
            },
            {
              value: 'Inappropriate urination',
              groupBy: 'urinary',
            },
            {
              value: 'Urinary health',
              groupBy: 'urinary',
            },
            {
              value: 'Teeth',
              groupBy: 'others',
            },
            {
              value: 'Others',
              groupBy: 'others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Limping, Joint issues',
                datafield: 'others',
              },
            },
          ],
        },
      },
      medications_currently_on: {
        title: 'Which medications is your pet currently taking?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'medications',
          required: false,
          datafield: 'medications',
          options: [
            {
              value: 'Metronidazole(Flagyl)',
            },
            {
              value: 'Anti-diarrheal tablets or liquid',
            },
            {
              value: 'Probiotics',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Imodium, Loperamide',
                datafield: 'others',
              },
            },
          ],
        },
      },
    },
    vomiting: {
      // period: 우선 생략
      experiencing_other_issues: {
        title: 'Is your pet experiencing\nany other issues?',
        description: 'This will help us better understand\nyour pet’s health.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: false,
          options: [
            {
              value: 'Diarrhea',
              groupBy: 'most asked',
            },
            {
              value: 'Ear',
              groupBy: 'most asked',
            },
            {
              value: 'Eye',
              groupBy: 'most asked',
            },
            {
              value: 'Behavior',
              groupBy: 'most asked',
            },
            {
              value: 'Lethargy',
              groupBy: 'most asked',
            },
            {
              value: 'Loss of appetite',
              groupBy: 'most asked',
            },
            {
              value: 'Toxic ingestion',
              groupBy: 'most asked',
            },
            {
              value: 'Weight loss',
              groupBy: 'most asked',
            },
            {
              value: 'Obesity',
              groupBy: 'most asked',
            },
            {
              value: 'Nose',
              groupBy: 'most asked',
            },
            {
              value: 'Heartworms',
              groupBy: 'most asked',
            },
            {
              value: 'Coughing',
              groupBy: 'respiratory',
            },
            {
              value: 'Sneezing',
              groupBy: 'respiratory',
            },
            {
              value: 'Stinky breath',
              groupBy: 'respiratory',
            },
            {
              value: 'Difficulty breathing',
              groupBy: 'respiratory',
            },
            {
              value: 'Skin',
              groupBy: 'skin',
            },
            {
              value: 'Itching',
              groupBy: 'skin',
            },
            {
              value: 'Fleas',
              groupBy: 'skin',
            },
            {
              value: 'Ticks',
              groupBy: 'skin',
            },
            {
              value: 'Inappropriate urination',
              groupBy: 'urinary',
            },
            {
              value: 'Urinary health',
              groupBy: 'urinary',
            },
            {
              value: 'Teeth',
              groupBy: 'others',
            },
            {
              value: 'Others',
              groupBy: 'others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Limping, Joint issues',
                datafield: 'others',
              },
            },
          ],
        },
      },
      medications_currently_on: {
        title: 'Which medications is your pet currently taking?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'medications',
          datafield: 'medications',
          required: false,
          options: [
            {
              value: 'Cerenia',
            },
            {
              value: 'Sucralfate',
            },
            {
              value: 'Famotidine',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Ondansetron, Omeprazole',
                datafield: 'others',
              },
            },
          ],
        },
      },
    },
    skin: {
      concerned_skin_issues: {
        title: 'What specific skin issues\nare you concerned about?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: true,
          options: [
            {
              value: 'Excessive itching',
            },
            {
              value: 'Redness',
            },
            {
              value: 'Scabbing',
            },
            {
              value: 'Hair loss',
            },
            {
              value: 'Sticky skin',
            },
            {
              value: 'Bad smell',
            },
            {
              value: 'Flaky skin or dandruff',
            },
            {
              value: 'Fleas or ticks',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Dermatitis, Allergies',
                datafield: 'others',
              },
            },
          ],
        },
      },
      area_of_skin_problems: {
        title: "What are the areas of\nyour pet's skin problem?",
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'skin_areas',
          required: true,
          options: [
            {
              value: 'Ear',
            },
            {
              value: 'Head',
            },
            {
              value: 'Chest',
            },
            {
              value: 'Underbelly',
            },
            {
              value: 'Anal area',
            },
            {
              value: 'Back legs',
            },
            {
              value: 'Armpits',
            },
            {
              value: 'Groin',
            },
            {
              value: 'Top of back',
            },
            {
              value: 'Front legs',
            },
            {
              value: 'Front paws',
            },
            {
              value: 'Back paws',
            },
            {
              value: 'Face and muzzle',
            },
            {
              value: 'Neck',
            },
          ],
        },
      },
      experiencing_other_issues: {
        title: 'Is your pet experiencing\nany other issues?',
        description: 'This will help us better understand\nyour pet’s health.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: false,
          options: [
            {
              value: 'Diarrhea',
              groupBy: 'most asked',
            },
            {
              value: 'Vomiting',
              groupBy: 'most asked',
            },
            {
              value: 'Ear',
              groupBy: 'most asked',
            },
            {
              value: 'Eye',
              groupBy: 'most asked',
            },
            {
              value: 'Behavior',
              groupBy: 'most asked',
            },
            {
              value: 'Lethargy',
              groupBy: 'most asked',
            },
            {
              value: 'Loss of appetite',
              groupBy: 'most asked',
            },
            {
              value: 'Toxic ingestion',
              groupBy: 'most asked',
            },
            {
              value: 'Weight loss',
              groupBy: 'most asked',
            },
            {
              value: 'Obesity',
              groupBy: 'most asked',
            },
            {
              value: 'Nose',
              groupBy: 'most asked',
            },
            {
              value: 'Heartworms',
              groupBy: 'most asked',
            },
            {
              value: 'Coughing',
              groupBy: 'respiratory',
            },
            {
              value: 'Sneezing',
              groupBy: 'respiratory',
            },
            {
              value: 'Stinky breath',
              groupBy: 'respiratory',
            },
            {
              value: 'Difficulty breathing',
              groupBy: 'respiratory',
            },
            {
              value: 'Itching',
              groupBy: 'skin',
            },
            {
              value: 'Fleas',
              groupBy: 'skin',
            },
            {
              value: 'Ticks',
              groupBy: 'skin',
            },
            {
              value: 'Inappropriate urination',
              groupBy: 'urinary',
            },
            {
              value: 'Urinary health',
              groupBy: 'urinary',
            },
            {
              value: 'Teeth',
              groupBy: 'others',
            },
            {
              value: 'Others',
              groupBy: 'others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Limping, Joint issues',
                datafield: 'others',
              },
            },
          ],
        },
      },
      medications_currently_on: {
        title: 'Which medications is your pet currently taking?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'medications',
          datafield: 'medications',
          required: false,
          options: [
            {
              value: 'Cephalexin',
            },
            {
              value: 'Cefpodoxime',
            },
            {
              value: 'Animax ointment',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Cytopoint injection',
                datafield: 'others',
              },
            },
          ],
        },
      },
    },
    ear: {
      concerned_ear_issues: {
        title: 'What specific ear issues\nare you concerned about?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: true,
          options: [
            {
              value: 'Swelling',
            },
            {
              value: 'Sensitive to touch',
            },
            {
              value: 'Excessive discharge',
            },
            {
              value: 'Bad smell',
            },
            {
              value: 'Redness',
            },
            {
              value: 'Itching (rubbing ears)',
            },
            {
              value: 'Head shaking',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Ear mites, Scabs',
                datafield: 'others',
              },
            },
          ],
        },
      },
      experiencing_other_issues: {
        title: 'Is your pet experiencing\nany other issues?',
        description: 'This will help us better understand\nyour pet’s health.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: false,
          options: [
            {
              value: 'Diarrhea',
              groupBy: 'most asked',
            },
            {
              value: 'Vomiting',
              groupBy: 'most asked',
            },
            {
              value: 'Eye',
              groupBy: 'most asked',
            },
            {
              value: 'Behavior',
              groupBy: 'most asked',
            },
            {
              value: 'Lethargy',
              groupBy: 'most asked',
            },
            {
              value: 'Loss of appetite',
              groupBy: 'most asked',
            },
            {
              value: 'Toxic ingestion',
              groupBy: 'most asked',
            },
            {
              value: 'Weight loss',
              groupBy: 'most asked',
            },
            {
              value: 'Obesity',
              groupBy: 'most asked',
            },
            {
              value: 'Nose',
              groupBy: 'most asked',
            },
            {
              value: 'Heartworms',
              groupBy: 'most asked',
            },
            {
              value: 'Coughing',
              groupBy: 'respiratory',
            },
            {
              value: 'Sneezing',
              groupBy: 'respiratory',
            },
            {
              value: 'Stinky breath',
              groupBy: 'respiratory',
            },
            {
              value: 'Difficulty breathing',
              groupBy: 'respiratory',
            },
            {
              value: 'Skin',
              groupBy: 'skin',
            },
            {
              value: 'Itching',
              groupBy: 'skin',
            },
            {
              value: 'Fleas',
              groupBy: 'skin',
            },
            {
              value: 'Ticks',
              groupBy: 'skin',
            },
            {
              value: 'Inappropriate urination',
              groupBy: 'urinary',
            },
            {
              value: 'Urinary health',
              groupBy: 'urinary',
            },
            {
              value: 'Teeth',
              groupBy: 'others',
            },
            {
              value: 'Others',
              groupBy: 'others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Limping, Joint issues',
                datafield: 'others',
              },
            },
          ],
        },
      },
      medications_currently_on: {
        title: 'Which medications is your pet currently taking?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'medications',
          datafield: 'medications',
          required: false,
          options: [
            {
              value: 'Otic suspension',
            },
            {
              value: 'Ear cleanser',
            },
            {
              value: 'Ear wipes',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Organic ear oil, Ear Miticide',
                datafield: 'others',
              },
            },
          ],
        },
      },
    },
    eye: {
      concerned_eye_issues: {
        title: 'What specific eye issues\nare you concerned about?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: true,
          options: [
            {
              value: 'Rubbing',
            },
            {
              value: 'Redness',
            },
            {
              value: 'Swelling',
            },
            {
              value: 'Tearing',
            },
            {
              value: 'Discharge',
            },
            {
              value: 'Squinting',
            },
            {
              value: 'Holding eye closed',
            },
            {
              value: 'Sensitivity to light',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Conjunctivitis, Entropion',
                datafield: 'others',
              },
            },
          ],
        },
      },
      experiencing_other_issues: {
        title: 'Is your pet experiencing\nany other issues?',
        description: 'This will help us better understand\nyour pet’s health.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: false,
          options: [
            {
              value: 'Diarrhea',
              groupBy: 'most asked',
            },
            {
              value: 'Vomiting',
              groupBy: 'most asked',
            },
            {
              value: 'Ear',
              groupBy: 'most asked',
            },
            {
              value: 'Behavior',
              groupBy: 'most asked',
            },
            {
              value: 'Lethargy',
              groupBy: 'most asked',
            },
            {
              value: 'Loss of appetite',
              groupBy: 'most asked',
            },
            {
              value: 'Toxic ingestion',
              groupBy: 'most asked',
            },
            {
              value: 'Weight loss',
              groupBy: 'most asked',
            },
            {
              value: 'Obesity',
              groupBy: 'most asked',
            },
            {
              value: 'Nose',
              groupBy: 'most asked',
            },
            {
              value: 'Heartworms',
              groupBy: 'most asked',
            },
            {
              value: 'Coughing',
              groupBy: 'respiratory',
            },
            {
              value: 'Sneezing',
              groupBy: 'respiratory',
            },
            {
              value: 'Stinky breath',
              groupBy: 'respiratory',
            },
            {
              value: 'Difficulty breathing',
              groupBy: 'respiratory',
            },
            {
              value: 'Skin',
              groupBy: 'skin',
            },
            {
              value: 'Itching',
              groupBy: 'skin',
            },
            {
              value: 'Fleas',
              groupBy: 'skin',
            },
            {
              value: 'Ticks',
              groupBy: 'skin',
            },
            {
              value: 'Inappropriate urination',
              groupBy: 'urinary',
            },
            {
              value: 'Urinary health',
              groupBy: 'urinary',
            },
            {
              value: 'Teeth',
              groupBy: 'others',
            },
            {
              value: 'Others',
              groupBy: 'others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Limping, Joint issues',
                datafield: 'others',
              },
            },
          ],
        },
      },
      medications_currently_on: {
        title: 'Which medications is your pet currently taking?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'medications',
          datafield: 'medications',
          required: false,
          options: [
            {
              value: 'Ophthalmic ointment',
            },
            {
              value: 'Ophthalmic suspension',
            },
            {
              value: 'Ophthalmic gel',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Eye rinse, Tobramycin',
                datafield: 'others',
              },
            },
          ],
        },
      },
    },
    behavior: {
      concerned_behavior_issues: {
        title: 'What specific behaviors\nare you concerned about?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          options: [
            {
              value: 'Excessive barking',
            },
            {
              value: 'Separation anxiety',
            },
            {
              value: 'Destructive behavior',
            },
            {
              value: 'Noise aversion',
            },
            {
              value: 'Aggression',
            },
            {
              value: 'Travel anxiety',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Biting, Scratching',
                datafield: 'others',
              },
            },
          ],
        },
      },
      recent_life_style_change: {
        title: 'Have there been any\nrecent lifestyle changes?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'changes',
          datafield: 'life_style_changes',
          required: false,
          options: [
            {
              value: 'Travel',
            },
            {
              value: 'Moving',
            },
            {
              value: 'Schedule changes',
            },
            {
              value: 'Household members change',
            },
            {
              value: 'A new pet',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., New job, Boarding',
                datafield: 'others',
              },
            },
          ],
        },
      },
      frequency: {
        title: 'How frequently\ndoes your pet show these behaviors?',
        component: {
          type: 'select',
          options: [
            {
              value: 'Multiple times a day',
            },
            {
              value: 'Daily',
            },
            {
              value: 'Weekly',
            },
            {
              value: 'Episodic (at certain triggers)',
            },
          ],
        },
      },
      experiencing_other_issues: {
        title: 'Is your pet experiencing\nany other issues?',
        description: 'This will help us better understand\nyour pet’s health.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: false,
          options: [
            {
              value: 'Diarrhea',
              groupBy: 'most asked',
            },
            {
              value: 'Vomiting',
              groupBy: 'most asked',
            },
            {
              value: 'Ear',
              groupBy: 'most asked',
            },
            {
              value: 'Eye',
              groupBy: 'most asked',
            },
            {
              value: 'Lethargy',
              groupBy: 'most asked',
            },
            {
              value: 'Loss of appetite',
              groupBy: 'most asked',
            },
            {
              value: 'Toxic ingestion',
              groupBy: 'most asked',
            },
            {
              value: 'Weight loss',
              groupBy: 'most asked',
            },
            {
              value: 'Obesity',
              groupBy: 'most asked',
            },
            {
              value: 'Nose',
              groupBy: 'most asked',
            },
            {
              value: 'Heartworms',
              groupBy: 'most asked',
            },
            {
              value: 'Coughing',
              groupBy: 'respiratory',
            },
            {
              value: 'Sneezing',
              groupBy: 'respiratory',
            },
            {
              value: 'Stinky breath',
              groupBy: 'respiratory',
            },
            {
              value: 'Difficulty breathing',
              groupBy: 'respiratory',
            },
            {
              value: 'Skin',
              groupBy: 'skin',
            },
            {
              value: 'Itching',
              groupBy: 'skin',
            },
            {
              value: 'Fleas',
              groupBy: 'skin',
            },
            {
              value: 'Ticks',
              groupBy: 'skin',
            },
            {
              value: 'Inappropriate urination',
              groupBy: 'urinary',
            },
            {
              value: 'Urinary health',
              groupBy: 'urinary',
            },
            {
              value: 'Teeth',
              groupBy: 'others',
            },
            {
              value: 'Others',
              groupBy: 'others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Limping, Joint issues',
                datafield: 'others',
              },
            },
          ],
        },
      },
      medications_currently_on: {
        title: 'Which medications is your pet currently taking?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'medications',
          datafield: 'medications',
          required: false,
          options: [
            {
              value: 'Alprazolam',
            },
            {
              value: 'Trazodone',
            },
            {
              value: 'Fluoxetine',
            },
            {
              value: 'Others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Diazepam, Clomipramine',
                datafield: 'others',
              },
            },
          ],
        },
      },
    },
    urination: {
      urination_frequency_change: {
        title: 'Has your pet’s urination\nfrequency changed?',
        component: {
          type: 'select',
          options: [
            {
              value: 'No change',
            },
            {
              label: 'Slightly increased / decreased',
              value: 'Slightly increased/decreased',
            },
            {
              label: 'Significantly increased / decreased',
              value: 'Significantly increased/decreased',
            },
            {
              value: 'Not sure',
            },
          ],
        },
      },
      usual_urination_frequency_per_day: {
        title: 'How many times does your pet urinate per day now?',
        description: "Even if you're unsure, please estimate based on recent observations",
        component: {
          type: 'num_per_day',
          placeholder: '3',
        },
      },
      color: {
        title: 'Have you noticed any changes in your pet’s urine color?',
        component: {
          type: 'select',
          datafield: 'option',
          mandatory: false,
          options: [
            {
              value: 'Blood in urine',
              label: 'Blood in urine\n(red or pink discoloration)',
            },
            {
              value: 'Unusual color',
              label: 'Unusual color (please specify)',
              extra_component: {
                type: 'select',
                datafield: 'unusal_color',
                placeholder: 'Choose color',
                options: [
                  {
                    value: 'Light yellow',
                  },
                  {
                    value: 'Dark yellow',
                  },
                  {
                    value: 'Bright yellow',
                  },
                  {
                    label: 'Clear/colorless',
                    value: 'Clear/colorless',
                  },
                  {
                    value: 'Brown or black',
                  },
                  {
                    value: 'Green',
                  },
                  {
                    value: 'Orange',
                  },
                  { value: 'Red or pink' },
                  {
                    value: 'Cloudy',
                  },
                ],
              },
            },
            {
              value: 'No change',
            },
          ],
        },
      },
      accidents: {
        title: 'Is your pet urinating\nsomewhere unusual?',
        component: {
          type: 'select',
          datafield: 'urinating_somewhere_unusual',
          options: [
            {
              value: true,
              label: 'Yes',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Owner’s bed, carpet',
                datafield: 'details',
                mandatory: false,
              },
            },
            {
              value: false,
              label: 'No',
            },
          ],
        },
      },
      odor: {
        title: 'Does your pet’s urine have a strong or unusual odor?',
        component: {
          type: 'select',
          mandatory: false,
          datafield: 'strong_or_unusual_odor',
          options: [
            {
              value: true,
              label: 'Yes',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Sweet, Ammonia-like, Fishy',
                datafield: 'details',
              },
            },
            {
              value: false,
              label: 'No',
            },
          ],
        },
      },
      related_behavior_changes: {
        title: 'Has your pet shown any urination-related behavioral changes?',
        description: 'Select all that apply.',
        component: {
          type: 'checkbox',
          subject: 'changes',
          required: false,
          datafield: 'options',
          options: [
            {
              label: 'Excessive licking of the genital area',
              value: 'Excessive licking of genital area',
            },
            {
              value: 'Spending more time in the litter box',
              enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'cat',
            },
            {
              value: 'Frequent attempts to urinate with little output (Straining or discomfort)',
            },
            {
              value: 'Changes in behavior',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Irritability, Hiding',
                datafield: 'changes_in_behavior',
              },
            },
          ],
        },
      },
      experiencing_other_issues: {
        title: 'Is your pet experiencing\nother issues?',
        description: 'This will help us better understand\nyour pet’s health.',
        component: {
          type: 'checkbox',
          subject: 'issues',
          datafield: 'issues',
          required: false,
          options: [
            {
              value: 'Diarrhea',
              groupBy: 'most asked',
            },
            {
              value: 'Vomiting',
              groupBy: 'most asked',
            },
            {
              value: 'Ear',
              groupBy: 'most asked',
            },
            {
              value: 'Eye',
              groupBy: 'most asked',
            },
            {
              value: 'Lethargy',
              groupBy: 'most asked',
            },
            {
              value: 'Loss of appetite',
              groupBy: 'most asked',
            },
            {
              value: 'Toxic ingestion',
              groupBy: 'most asked',
            },
            {
              value: 'Weight loss',
              groupBy: 'most asked',
            },
            {
              value: 'Obesity',
              groupBy: 'most asked',
            },
            {
              value: 'Nose',
              groupBy: 'most asked',
            },
            {
              value: 'Heartworms',
              groupBy: 'most asked',
            },
            {
              value: 'Coughing',
              groupBy: 'respiratory',
            },
            {
              value: 'Sneezing',
              groupBy: 'respiratory',
            },
            {
              value: 'Stinky breath',
              groupBy: 'respiratory',
            },
            {
              value: 'Difficulty breathing',
              groupBy: 'respiratory',
            },
            {
              value: 'Skin',
              groupBy: 'skin',
            },
            {
              value: 'Itching',
              groupBy: 'skin',
            },
            {
              value: 'Fleas',
              groupBy: 'skin',
            },
            {
              value: 'Ticks',
              groupBy: 'skin',
            },
            {
              value: 'Teeth',
              groupBy: 'others',
            },
            {
              value: 'Others',
              groupBy: 'others',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Limping, Joint issues',
                datafield: 'others',
              },
            },
          ],
        },
      },
      medications_currently_on: {
        title: 'Is your pet currently on any medication?',
        description: 'Include prescription, over-the-counter, or supplements.',
        component: {
          type: 'select',
          mandatory: false,
          datafield: 'is_on_medication',
          options: [
            {
              value: true,
              label: 'Yes',
              extra_component: {
                type: 'text',
                placeholder: 'e.g., Sistade',
                datafield: 'details',
              },
            },
            {
              value: false,
              label: 'No',
            },
          ],
        },
      },
    },
    others: {},
  },
  common_checkup: {
    period: {
      title: 'How long has your pet been showing these issues?',
      description: 'Choose your best guess.',
      component: {
        type: 'period',
        options: [
          {
            value: 'Day(s)',
            label: 'Day(s)',
          },
          {
            value: 'Week(s)',
            label: 'Week(s)',
          },
          {
            value: 'Month(s)',
            label: 'Month(s)',
          },
        ],
      },
    },
    vaccination: {
      title: 'What vaccines has your pet\nreceived?',
      component: {
        type: 'checkbox',
        subject: 'vaccines',
        datafield: 'vaccines',
        required: false,
        options: [
          {
            value: 'Rabies',
          },
          {
            value: 'DHPP',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() !== 'cat',
          },
          {
            value: 'Leptospirosis',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'dog',
          },
          {
            value: 'Lyme',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'dog',
          },
          {
            value: 'Kennel Cough',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'dog',
          },
          {
            value: 'Canine Influenza',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'dog',
          },
          {
            value: 'FeLV',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'cat',
          },
          {
            value: 'FVRCP',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'cat',
          },
          {
            value: 'Chlamydia',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'cat',
          },
          {
            value: 'Bordetella',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'cat',
          },
          {
            value: 'FIV',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() === 'cat',
          },
          {
            value: 'Heartworm',
            enabled: ({ pet }) => pet?.kind.main?.toLowerCase() !== 'cat',
          },
          {
            value: 'Others',
            extra_component: {
              type: 'text',
              placeholder: 'e.g., Parvovirus, etc.',
              datafield: 'others',
            },
          },
        ],
      },
    },
    flea_and_tick_preventions_on: {
      title: 'What kind of flea & tick\nprevention has your pet been\non?',
      component: {
        type: 'checkbox',
        subject: 'prevention',
        datafield: 'preventions',
        required: false,
        options: [
          {
            value: 'Chewables or pills',
          },
          {
            value: 'Topical treatments',
          },
          {
            value: 'Collars',
          },
          {
            value: 'Others',
            extra_component: {
              type: 'text',
              placeholder: 'e.g., Shampoo, Spray, Powder',
              datafield: 'others',
            },
          },
        ],
      },
    },
  },
}

Object.keys(loadedData.checkup).forEach(
  mainConcern =>
    (loadedData.checkup[mainConcern] = Object.assign(
      loadedData.checkup[mainConcern],
      loadedData.common_checkup
    ))
)
